export const FLAG_GETTING_DISCOUNT_CODE_CATEGORIES =
  'FLAG_GETTING_DISCOUNT_CODE_CATEGORIES';
export const GET_DISCOUNT_CODE_CATEGORIES = 'GET_DISCOUNT_CODE_CATEGORIES';
export const CLEAR_DISCOUNT_CODE_CATEGORIES = 'CLEAR_DISCOUNT_CODE_CATEGORIES';
export const GET_DISCOUNT_CODE_CATEGORY = 'GET_DISCOUNT_CODE_CATEGORY';
export const CLEAR_DISCOUNT_CODE_CATEGORY = 'CLEAR_DISCOUNT_CODE_CATEGORY';
export const FLAG_DISCOUNT_CODE_CATEGORY_ACTIVITY =
  'FLAG_DISCOUNT_CODE_CATEGORY_ACTIVITY';
